import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@paypalcorp/pp-react';
import { recordIntent, ADD_DEV_RPS } from '../../../lib/appcenterIntent';
import { CHECKOUT } from '../../../lib/constants';
import { fireDetailsPageComponentFailureFpti } from '../../../lib/helpers';

const DetailsCTA = ({
  componentContent,
  handleClickFPTI,
  fptiImpression,
  app
}) => {
  const { ctaItems } = componentContent;

  const handleClick = (fptiLink, url) => {
    handleClickFPTI(fptiLink);
    if (
      componentContent.toolKey === CHECKOUT &&
      fptiLink === 'add_your_developer'
    ) {
      rpsRecordIntent(url);
    } else {
      window.open(url, '_blank');
    }
  };

  const rpsRecordIntent = url => {
    recordIntent({
      csrf: app.csrf,
      productArr: [ADD_DEV_RPS]
    }).finally(() => {
      window.open(url, '_blank');
    });
  };

  if (!ctaItems) {
    fireDetailsPageComponentFailureFpti({
      data: { ctaItems },
      componentName: 'DetailsCTASection',
      fptiImpression
    });
    return null;
  }

  const buffData = JSON.parse(ctaItems);
  const ctaItemValues = Object.keys(buffData).map(key => buffData[key]);

  return (
    <section id="details-cta">
      <div className="details-cta-container">
        {ctaItemValues.map((value, i) => (
          <div key={`details-cta-${i}`} className="details-cta-container-item">
            <h3>{value.title}</h3>
            <p className="font-size-p">{value.subtitle}</p>
            <Button
              onClick={() =>
                handleClick(
                  i === 0 ? 'connect_get_started' : 'add_your_developer',
                  value.buttonUrl
                )
              }
              secondary
            >
              {value.buttonText}
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
};

DetailsCTA.propTypes = {
  componentContent: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  app: PropTypes.object,
  fptiImpression: PropTypes.func.isRequied
};

export default DetailsCTA;
